<svg width="38" height="30" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1768_24935)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1 15C1 11.134 4.13401 8 8 8H30C33.866 8 37 11.134 37 15C37 18.866 33.866 22 30 22H8C4.13401 22 1 18.866 1 15ZM7 14.45H17V15.55H7V14.45ZM27.6978 16.0092C27.8765 16.1448 28.1235 16.1448 28.3022 16.0092L30.0935 14.6501C30.2948 14.4974 30.3149 14.2022 30.1363 14.0235C29.9869 13.8741 29.7494 13.8602 29.5836 13.9909L28.3096 14.9956C28.128 15.1388 27.872 15.1388 27.6904 14.9956L26.4164 13.9909C26.2506 13.8602 26.0131 13.8741 25.8637 14.0235C25.6851 14.2022 25.7052 14.4974 25.9065 14.6501L27.6978 16.0092Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_1768_24935">
<rect width="38" height="30" rx="3" fill="white"/>
</clipPath>
</defs>
</svg>
